import React from 'react';
import clsx from 'clsx';
import { getBackgroundColorClassName } from '~/utilities/component-color';

/**
 * @param {object} props
 * @param {string} props.color - The color of the divider
 * @param {'horizontal' | 'vertical'} props.orientation - The orientation of the divider
 * @returns {JSX.Element}
 */
const DividerLine = ({ color, orientation }) => {
  if (!color || color === 'None') {
    return null;
  }

  return <div className={clsx('divider-line', orientation, getBackgroundColorClassName(color))} />;
};

export default DividerLine;
